import { render, staticRenderFns } from "./JdsTextProvider.vue?vue&type=template&id=54223456&scoped=true&"
import script from "./JdsTextProvider.vue?vue&type=script&lang=ts&"
export * from "./JdsTextProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54223456",
  null
  
)

export default component.exports